var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InvoicesTable',{ref:"invoicesTable",attrs:{"standalone":true,"enableSelection":true,"showStats":false,"showCloseInvoicing":true}})}
var staticRenderFns = []

export { render, staticRenderFns }